import { render, staticRenderFns } from "./loginRegisterDialog.vue?vue&type=template&id=1630e8e2&scoped=true"
import script from "./loginRegisterDialog.vue?vue&type=script&lang=ts"
export * from "./loginRegisterDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../soccer/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1630e8e2",
  null
  
)

export default component.exports